<template>
    <div>
        <el-row class="tac">

            <el-col :xs="0" :sm="0" :md="4" :lg="4" :xl="4" style="box-shadow: 3px 0 3px #DDDDDD;">
              <el-menu
                  style="min-height:calc(100vh - 70px);"
                  background-color="#4f4f4f"
                  text-color="#ccc"
                  active-text-color="#fff"
                  :default-active="activeIndex"
                  @select="handleSelect"
              >

                <el-menu-item index="1" @click="currentComponent='cgvComponent'">{{buttons[0]}}</el-menu-item>
                <el-menu-item index="2" @click="currentComponent='calComponent'">{{buttons[1]}}</el-menu-item>
                <el-menu-item index="3" @click="currentComponent='caeComponent'">{{buttons[2]}}</el-menu-item>
                    <el-menu-item index="4" @click="callChildMethod(), currentComponent='CalculateEquivalentParameters', dynamicMessage='Äquivalente Parameter'">Äquivalente Parameter</el-menu-item>
                    <el-menu-item index="5" @click="callChildMethod(), currentComponent='CalculateEquivalentParameters', dynamicMessage='Permeabilität und AL'">Permeabilität und AL</el-menu-item>
                    <el-menu-item index="6" @click="callChildMethod(), currentComponent='CalculateEquivalentParameters', dynamicMessage='Induktivität'">Induktivität</el-menu-item>
                    <el-menu-item index="7" @click="callChildMethod(), currentComponent='CalculateEquivalentParameters', dynamicMessage='Anzahl der Windungen'">Anzahl der Windungen</el-menu-item>
                    <el-menu-item index="8" @click="callChildMethod(), currentComponent='CalculateEquivalentParameters', dynamicMessage='Ausgangsleistung'">Ausgangsleistung</el-menu-item>
                    <el-menu-item index="9" @click="callChildMethod(), currentComponent='CalculateEquivalentParameters', dynamicMessage='Gewicht'">Gewicht</el-menu-item>
                    <el-menu-item index="10" @click="callChildMethod(), currentComponent='CalculateEquivalentParameters', dynamicMessage='Luftspalt und Induktivität'">Luftspalt und Induktivität</el-menu-item>
                    <el-menu-item index="11" @click="callChildMethod(), currentComponent='CalculateEquivalentParameters', dynamicMessage='Dichte'">Dichte</el-menu-item>



                </el-menu>



            </el-col>
          <el-col :xs="24" :sm="24" :md="20" :lg="20" :xl="20" class="contain" style="height: 90vh;">
            <component :is="currentComponent" :message="dynamicMessage" ref="calculateComponent" @changeMsg="changes"></component>
          </el-col>
        </el-row>
    </div>
</template>

<script>
    import request from "@/utils/request";
    import cgvComponent from "@/DE/forIfcores/search/CoreCalculations/cgvComponent.vue";
    import calComponent from "@/DE/forIfcores/search/CoreCalculations/calComponent.vue";
    import caeComponent from "@/DE/forIfcores/search/CoreCalculations/caeComponent.vue";
    import CalculateEquivalentParameters
      from "@/DE/forIfcores/search/CoreCalculations/CalculateEquivalentParameters.vue";

    export default {
        name: "search",
      components: {
        cgvComponent,
        calComponent,
        caeComponent,
        CalculateEquivalentParameters
      },
        data(){
            return{
                path:this.$route.path,//设置菜单高亮
                form:{chuangkou:0.4},
                al:{},
                ae:{},
                titles:["Die qualifizierten Kerninformationen werden entsprechend der Ausgangsleistung abgefragt",
                    "Die förderfähigen Kerninformationen werden nach AL abgefragt",
                    "Die förderfähigen Kerninformationen werden nach Ae abgefragt"],
                labels:["Frequenz","Stromdichte","Fensterfüllfaktor",
                    "Magnetische Flussdichte", "Power Min", "Power Max",
                    "AL Min", "Ae Min","AL Max","Ae Max",],
                placeholders:["Frequenzeinheit:KHz","Einheit: A/mm² Max 4A/mm²",
                    "Einheit: KW allgemein benutzt 0.4", "Einheit: T 1T=1000mT",
                    "Einheit: W", "Einheit: W",
                    "Mehr als das, schreibe 0 für alle",
                    "Größer als dies, schreibe 0 für alle",
                    "Suche nach AL größer oder gleich diesem Wert",
                    "Suche nach AL kleiner oder gleich diesem Wert",
                    "Suche nach Ae größer oder gleich diesem Wert",
                    "Suche nach Ae kleiner oder gleich diesem Wert",
                ],
                buttons:["Ausgangsleistungsabfrage","Entsprechend AL-Abfrage","Entsprechend Ae-Abfrage",
                    "Vorwärtszeichnung", "Vollbrücke Push-Pull", "Schließen", "Absenden"],
                tableData:null,
                tableData2:null,
                Categories:null,
                loading:false,
                gv: true,
                aldiv:false,
                aediv:false,
                isPC:'true',
              currentComponent: 'cgvComponent', // 初始值应为字符串
              isPhone: "",
              dynamicMessage: null,
              someBooleanValue: false,
              activeIndex: '1'

            }
        }
        ,methods:{
        handleSelect(index) {
          this.activeIndex = index;
        },
        callChildMethod() {
          this.$nextTick(() => {
            if (this.$refs.calculateComponent && typeof this.$refs.calculateComponent.changeIsShow === 'function') {
              this.$refs.calculateComponent.changeIsShow();
            } else {
              console.error('changeIsShow 方法未找到');
            }
          });
        },
        changes(data){
          this.$emit('changeMsg', data)
        },
        guanbi(){
                this.$emit('changeMsg', true)
            },
            _isMobile() {
                let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
                return flag;
            }
        },
        created() {
            if (this._isMobile()) {
                if(this._isMobile().indexOf("iPad")!=-1){
                    this.isPC=true;
                }else {
                    this.isPC=false;
                }

            } else {
                // alert("pc端");
                // this.$router.replace('/test');
                this.isPC=true;
            }
        },

    }
</script>

<style scoped>
a{
  text-decoration:underline ;
  color: #409EFF;
  cursor: pointer;
  display: inline-block;
  width: 90px;
  text-align: center;
  line-height: 30px;
  margin-left: 10px;
  border: 1px solid #cccccc;
  border-radius: 5px;
  margin-bottom: 5px;
}
.tac{
  height: calc(100vh - 70px);
  z-index: 999;
  border-top:1px solid #cccccc ;
}
/*html{*/
/*    !*隐藏滚动条，当IE下溢出，仍然可以滚动*!*/
/*    -ms-overflow-style:none;*/
/*    !*火狐下隐藏滚动条*!*/
/*    overflow:-moz-scrollbars-none;*/
/*}*/


/*::-webkit-scrollbar{*/
/*    display:none;*/
/*}*/

.demo-image .block {
  padding: 10px 0;
  text-align: center;
  display: inline-block;
  box-sizing: border-box;
  vertical-align: top;
}
/* 隐藏 x 轴滚动条 */
.contain {
  overflow-x: scroll; /* 启用 x 轴滚动 */
  overflow-y: auto; /* 启用 y 轴滚动 */
}

/* Chrome, Safari 和 Opera */
.contain::-webkit-scrollbar {
  width: 12px; /* 设置滚动条宽度 */
}

.contain::-webkit-scrollbar:horizontal {
  display: none; /* 隐藏 x 轴滚动条 */
}

/* Firefox */
.contain {
  scrollbar-width: thin; /* 设置滚动条宽度 */
}

.contain {
  scrollbar-color: transparent; /* 隐藏 x 轴滚动条 */
}

/* IE 和 Edge */
.contain {
  -ms-overflow-style: -ms-autohiding-scrollbar; /* 仅隐藏 x 轴滚动条 */
}


</style>




